import React, { useCallback, useRef, useState } from 'react'
import { shallowEqual } from 'react-redux'
import { Link } from 'react-router-dom'
import LogoutButton from '../components/auth/LogoutButton'
import TopBarTaskList from './components/tasks/TopBarTaskList'
import TopBarActiveTask from './components/tasks/TopBarActiveTask'
import Icon from '../components/Icon'
import { actionCreators as myActiveTaskActionCreators } from '@/store/myActiveTask'
import Resx from '../components/Resx'
import classnames from 'classnames'
import debug from 'debug'

import {
  Collapse,
  Navbar,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import { MainMenu } from '@/components/Layout/MainMenu'
import { TabNavItems, TabContent, TabPane } from '@/components/tabs'
import { useReduxState } from '@/hooks/reduxState'
import { useDispatch } from '@/hooks/dispatch'
import { CreateTicketButton } from '@/internal-app/pages/tickets/createTicketButton'
import { BackgroundJobMenuItem } from '@/components/backgroundJobs/backgroundJobMenuItem'
import GoToBackgroundJobsLink from '@/components/backgroundJobs/goToBackgroundJobsLink'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'
import { actionCreators as identityActions } from '@/store/Identity'
import { NotificationWidget } from '@/components/notifications/widget'
// import getComponentKey from '@/utils/getComponentKey'

const log = debug('app:menu')

const Menu = React.memo(function Menu () {
  const { userName, impersonatorUserId, myActiveTask, isNavSmall } = useReduxState(state => ({
    userName: state.identity.user.profile.name,
    userId: state.identity.user.profile.id,
    impersonatorUserId: state.identity.user.profile.ImpersonatorUserId,
    myActiveTask: state.myActiveTask,
    isNavSmall: state.menu.isNavSmall
  }), shallowEqual)
  const [activateTask, deactivateTask] = useDispatch([
    myActiveTaskActionCreators.activateTask,
    myActiveTaskActionCreators.deactivateTask
  ])
  const [activeTab, setActiveTab] = useState('0')
  const taskDropdown = useRef(null)
  const onTaskNavigate = useCallback(() => taskDropdown.current.toggle(), [])

  const hasActiveTask = myActiveTask.activeTask != null
  const activeTabId = hasActiveTask ? activeTab : '1'
  const impersonating = !!impersonatorUserId
  return (
    <React.Fragment>
      <Navbar dark expand className={classnames({ 'navbar--small': isNavSmall })}>
        <Link className='header__logo' to='/'><Resx name='Common.InternalApp' /></Link>
        <UncontrolledDropdown className='dropdown--profile'>
          <DropdownToggle nav className='nav-link--top'>
            <Icon name='user-circle' className={impersonating ? 'impersonating' : ''} />
          </DropdownToggle>
          <DropdownMenu className=''>
            <h6 className='dropdown-header'>{impersonating
              ? <React.Fragment><Resx name={'UserProfile.Impersonating'} /> <i className={'impersonating'}>{userName}</i></React.Fragment>
              : userName
            }</h6>
            {!impersonating &&
              <DropdownItem>
                <Link to='/user-profile'><Icon name='bxs-user-detail' /> <Resx name='Common.ShowProfile' /></Link>
              </DropdownItem>
            }
            <DropdownItem>
              <Link to='/dashboard-settings'><Icon name='bxs-dashboard' /> <Resx name='Common.DashboardWidgets' /></Link>
            </DropdownItem>
            <DropdownItem>
              <GoToBackgroundJobsLink showIcon />
            </DropdownItem>
            <div className='dropdown-divider' />
            {impersonating && <StopImpersonationItem />}
            <LogoutButton Component={DropdownItem} />
          </DropdownMenu>
        </UncontrolledDropdown>
        <NotificationWidget />
        <UncontrolledDropdown ref={taskDropdown} direction='right' className={hasActiveTask ? 'dropdown--button dropdown--tasks active' : 'dropdown--button dropdown--tasks'}>
          <DropdownToggle nav>
            {hasActiveTask ? (
              <div className='task-label'>
                <small className='tasle-label__title'><Resx name='Tasks.ActiveTask' /></small> <small>#</small><span>{myActiveTask.activeTask.id}</span>
              </div>
            ) : (
              <div className='d-task-notify'><Icon name='task' /><span> <Resx name='Tasks.NewTask' /></span></div>
            )}
          </DropdownToggle>
          {/* TASKS!!!!!! */}
          <DropdownMenu className='dropdown-menu--last'>
            <div>
              <TabNavItems
                activeTabId={activeTabId}
                onClick={setActiveTab}
                items={[hasActiveTask ? {
                  id: '0',
                  text: (
                    <React.Fragment><Resx name='Tasks.ActiveTask' />
                      <i className='icon-dot icon-dot--green' />
                    </React.Fragment>
                  )
                } : null, {
                  id: '1',
                  text: <Resx name='Tasks.TasksTitle' /> /* <small className='task-count'>({tasksCount})</small> */ }
                ].filter(x => x)}>
                <CreateTicketButton className='d-task__create-ticket btn btn-xs btn-purple' />
              </TabNavItems>
              <TabContent activeTab={activeTabId}>
                {hasActiveTask && <TabPane tabId='0'>
                  <TopBarActiveTask changeRequestItemsKey={myActiveTask.activeTask.id} task={myActiveTask.activeTask} activating={myActiveTask.activating} onNavigate={onTaskNavigate} />
                </TabPane>}
                <TabPane tabId='1'>
                  <TopBarTaskList
                    activeTask={myActiveTask.activeTask}
                    activateTask={activateTask}
                    activating={myActiveTask.activating}
                    deactivateTask={deactivateTask}
                    onNavigate={onTaskNavigate} />
                </TabPane>
              </TabContent>
            </div>
          </DropdownMenu>
          {/* END TASKS!!!!!! */}
        </UncontrolledDropdown>
        <BackgroundJobMenuItem collapsed={isNavSmall} />
        <Collapse navbar>
          <MainMenu />
        </Collapse>
      </Navbar>
    </React.Fragment>
  )
})

const StopImpersonationItem = () => {
  const { localize } = useLocalization()
  const dispatch = useDispatch()
  const stopImpersonation = useCallback(() => {
    context.api.loginService.stopImpersonation()
      .then(() => {
        dispatch(identityActions.userExpired())
        dispatch(identityActions.loadUser())
      }).catch((err) => {
        log(err)
      })
  }, [dispatch])
  return (
    <a className='dropdown-item' onClick={stopImpersonation}><Icon name='log-out' /> {localize('UserProfile.StopImpersonation')}</a>
  )
}

export default Menu



// WEBPACK FOOTER //
// ./src/internal-app/menu.js